import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Table, Card, Avatar, Button, Link, Pagination, Spin } from 'components/elements';
import Axios from 'axios';
import { BASE_URL, PAGE_SIZE } from '../../../inc/constants';
import { getAPIDefaultHeaders, handleCatch, handleEntityDelete } from '../../../inc/functions';

const ParentCategory = ({className, category, onDelete}) => {
  const Header = (
    <div className={`${className}__header`}>
      {category.name}
      <div className={`${className}__header__link`}>
        <Link to={`/categories/${category.id}/edit/`}>
          <Button small secondary>
          ویرایش
          </Button>
        </Link>
        <Button onClick={() => onDelete(category.id)} error small>حذف</Button>
      </div>
      
    </div>
  );
  const columns = [
    {
      title: 'عنوان دسته',
      dataIndex: 'name'
    },
    {
      title: 'نام انگلیسی (slug)',
      dataIndex: 'slug',
    },
	{
		title: 'فعال',
		dataIndex: 'is_active',
		render: i => i ? 'فعال' : 'غیرفعال'
	},
    {
      title: '',
      dataIndex: 'id',
      style: {width: 200},
      render: id => (
        <>
          <Link to={`/categories/${id}/edit/`}>
            <Button small secondary>
            ویرایش
            </Button>
          </Link>
          <Button onClick={() => onDelete(id)} small error>حذف</Button>
        </>
      ) 
    },
  ];
  return (
    <div className={className}>
      {Header}
      {category.children.length > 0 &&  <Table columns={columns} dataSource={category.children} />}
    </div>
  );
};
const StyledParentCategory = styled(ParentCategory)`
  margin-bottom: 35px;
  border: 1px solid #eee;
  &__header {
    background-color: rgba(0, 0, 0, .05);
    text-align: center;
    font-size: 24px;
    padding: 10px 0;
    color: #666;
    position: relative;
    &__link{
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

const CategoryList = ({ className }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  
  useEffect(() => {
    load();
  }, [page]);

  const load = () => {
    setLoading(true);
    Axios.get(`${BASE_URL}/admin/categories/?page=${page}&parent__isnull=True`, getAPIDefaultHeaders()).then((res) => {
      setData(res.data);
      setLoading(false);
    }).catch((err) => {
      handleCatch(err);
      setLoading(false);
    });
  };
  const handleDelete = (id) => {
    if (!window.confirm('این مورد حذف شود؟')) {
      return;
    }
    setLoading(true);
    Axios.delete(`${BASE_URL}/admin/categories/${id}/`, getAPIDefaultHeaders())
    .then((res) => {
      load();
    }).catch((err) => {
      handleCatch(err);
      setLoading(false);
    })
  }

  const cardMeta = (
    <div style={{textAlign: 'left'}}>
      <Link to="/categories/new/">
        <Button small>دسته جدید</Button>
      </Link>
    </div>
  );

  return (
    <Card title="دسته‌بندی‌ها" meta={cardMeta}>
      <Spin active={loading}>
        {data?.results.map( (parent) => <StyledParentCategory onDelete={(id) => handleEntityDelete('categories', id, 'دسته', setLoading, load)} category={parent} /> )}
        <Pagination count={data?.count || 0} current={page} onChange={setPage}/>
      </Spin>
    </Card>
  );
};

const StyledCategoryList = styled(CategoryList)`
`;

export default StyledCategoryList;
